export const colors = ['#3266cc', '#dc3811', '#ff9902', '#0d9618', '#992299']

export const generateNewColor = () => {
  const color = colors[0]
  colors.shift()
  colors.push(color)
  return color
}
